
import React from "react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";

interface AuthFormContainerProps {
  children: React.ReactNode;
  title?: string;
  description?: string;
}

const AuthFormContainer: React.FC<AuthFormContainerProps> = ({ 
  children, 
  title = "BoardSight Course Access",
  description = "Sign in or create an account to access your course materials."
}) => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-techne-primaryPurple">
            {title}
          </h2>
          <Separator className="my-6" />
        </div>
        
        <Card className="border-techne-purple/20 shadow-sm">
          <CardHeader className="text-center">
            <CardTitle className="text-xl text-techne-primaryPurple">
              Welcome
            </CardTitle>
            <CardDescription>
              {description}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {children}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AuthFormContainer;
